import React, { useState } from 'react';
import { Box, TextField, Button, Typography, List, ListItem, ListItemText, Chip, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

// Mock initial sponsors
const initialSponsors = [
  { id: 1, name: 'John Doe', email: 'john@example.com', relationship: 'Brother', status: 'approved' },
  { id: 2, name: 'Mary Smith', email: 'mary@example.com', relationship: 'Aunt', status: 'pending' },
];

const statusColor = {
  approved: 'success',
  pending: 'warning',
  revoked: 'default',
};

const AddSponsor = () => {
  const [sponsors, setSponsors] = useState(initialSponsors);
  const [form, setForm] = useState({ name: '', email: '', relationship: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAddSponsor = (e) => {
    e.preventDefault();
    if (!form.email || !form.name || !form.relationship) return;
    setLoading(true);
    // Mock API call
    setTimeout(() => {
      setSponsors([
        ...sponsors,
        { id: Date.now(), ...form, status: 'pending' },
      ]);
      setForm({ name: '', email: '', relationship: '' });
      setLoading(false);
    }, 800);
  };

  const handleRevoke = (id) => {
    setSponsors(sponsors.map(s => s.id === id ? { ...s, status: 'revoked' } : s));
  };

  return (
    <Box>
      <form onSubmit={handleAddSponsor} style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 16 }}>
        <TextField
          label="Sponsor Name"
          name="name"
          value={form.name}
          onChange={handleChange}
          size="small"
          required
        />
        <TextField
          label="Sponsor Email"
          name="email"
          value={form.email}
          onChange={handleChange}
          size="small"
          type="email"
          required
        />
        <TextField
          label="Relationship"
          name="relationship"
          value={form.relationship}
          onChange={handleChange}
          size="small"
          required
        />
        <Button type="submit" variant="contained" color="primary" disabled={loading} sx={{ minWidth: 120 }}>
          {loading ? 'Sending...' : 'Send Invite'}
        </Button>
      </form>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>Current Sponsors</Typography>
      <List dense>
        {sponsors.map(s => (
          <ListItem key={s.id} secondaryAction={
            s.status !== 'revoked' && (
              <IconButton edge="end" aria-label="revoke" onClick={() => handleRevoke(s.id)}>
                <DeleteIcon />
              </IconButton>
            )
          }>
            <ListItemText
              primary={`${s.name} (${s.relationship})`}
              secondary={s.email}
            />
            <Chip label={s.status.charAt(0).toUpperCase() + s.status.slice(1)} color={statusColor[s.status]} size="small" sx={{ ml: 1 }} />
          </ListItem>
        ))}
        {sponsors.length === 0 && (
          <ListItem>
            <ListItemText primary="No sponsors added yet." />
          </ListItem>
        )}
      </List>
    </Box>
  );
};

export default AddSponsor; 